import { render, staticRenderFns } from "./lazyload.vue?vue&type=template&id=0c2235e5&"
import script from "./lazyload.vue?vue&type=script&lang=js&"
export * from "./lazyload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports